import axios from "axios";
import { PaginateModel } from "../../models/PaginateModel";
import { PaymentRequestModel, SearchModel } from "../../models/PaymentRequestModel";
import { PAYMENT_REQUEST_ENDPOINT, STORES_ENDPOINT } from "../../constants/endpoints";
import { IResponseModel } from "../../models/CommonModel";
import { IAxiosSuccess } from "../../models/AxiosModel";


export interface PaymentRequestListModel {
  paginate_data: PaginateModel<PaymentRequestModel>,
  sub_total: number
}

export function getList(params?: SearchModel) {
  return axios.get<PaymentRequestListModel>(`${PAYMENT_REQUEST_ENDPOINT}`, {params})
}

export function getStoreDebt(id: number) {
  return axios.get<IResponseModel>(`${STORES_ENDPOINT}/debt/${id}`)
}

export function createRequest(params: PaymentRequestModel) {
  return axios.post<IAxiosSuccess>(PAYMENT_REQUEST_ENDPOINT, params)
}

export function updateRequest(params: PaymentRequestModel) {
  return axios.post<IAxiosSuccess>(`${PAYMENT_REQUEST_ENDPOINT}/${params.id}`, params)
}

export function updateRequestStatus(id: number, status: string) {
  return axios.post<IAxiosSuccess>(`${PAYMENT_REQUEST_ENDPOINT}/update-status`, {id, status})
}